import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  initialize() {
  }

  connect() {
  }
  
  disconnect() {
  }

  showModal = (event) => {
    event.preventDefault();
    //console.log("modal#showModal");
    //console.log(this.element.id, event.detail)
    if (this.element.id === event.detail[0]) {
      this.element.setAttribute('origin', event.detail[1]);
      // Formular der angeklickten Versandoption merken
      if (event.detail[2]) {
        this.element.setAttribute('form-id', event.detail[2]);
      }
      this.element.classList.remove("fade");
      this.element.classList.add("show");
      document.querySelector("body").classList.add("modal-open");
    }
  }

  hideModal = (event) => {
    this.element.classList.remove("show");
    this.element.classList.add("fade");
    document.querySelector("body").classList.remove("modal-open");

}

  submitForm = (event) => {
    //console.log("modal#submitForm");
    let formId = event.target.getAttribute("data-form");
    //console.log(formId);
    if (formId == "frm_other") {
      // Wir haben generische Versandhinweise angezeigt
      // und müssen jetzt das eigentliche Zielformular
      // aus dem origin-Attribut des Modals holen.
      const modal = document.getElementById("other");
      formId = "frm_" + modal.getAttribute("origin");
    }
    //console.log(formId);
    // Formular der angeklickten Versandoption bevorzugen, sonst Rueckfall auf
    // die Suche ueber die CSS-Klasse.
    const clickedFormId = this.element.getAttribute("form-id");
    const form = clickedFormId ? document.getElementById(clickedFormId) : document.querySelector("form." + formId);
    //console.log(form);
    if (!form) {
      return;
    }
    this.element.classList.remove("show");
    this.element.classList.add("fade");
    document.querySelector("body").classList.remove("modal-open");
    form.submit();
  }
}
